import { render, staticRenderFns } from "./CaraWeb.vue?vue&type=template&id=5089ac48"
import script from "./CaraWeb.vue?vue&type=script&lang=ts"
export * from "./CaraWeb.vue?vue&type=script&lang=ts"
import style0 from "./CaraWeb.vue?vue&type=style&index=0&id=5089ac48&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports